<template>
  <w-icon-wrapper
    :height='21.47'
    :width='24'
    icon-name='work-archived-icon'
    view-box='0 0 24 21.47'
  >
    <g
      id="_117_Archiv_Icon"
      data-name="117_Archiv_Icon"
      transform="translate(-7240 -2919.355)"
    >
      <path
        id="Pfad_59719"
        data-name="Pfad 59719"
        d="M3.87,7.7H20.12v13.13H3.87ZM2,3.356H22V5.7H2Zm-2-2V7.7H1.87v15.13H22.12V7.7H24V1.355Z"
        transform="translate(7240 2918)"
        fill="currentColor"
      />
      <path
        id="Pfad_59720"
        data-name="Pfad 59720"
        d="M15.059,14.445H8.934a1,1,0,0,1,0-2h6.125a1,1,0,0,1,0,2"
        transform="translate(7240 2918)"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>
  
  <script>
  export default { name: 'WorkIconArchived' };
  </script>
  